// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2ef2d06b","703":"adca340c"}[chunkId] + ".chunk.js";
};